import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../utils/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState('pt');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    
    if (typeof window !== 'undefined') {
      // 1. Check URL parameter override (e.g., ?lang=en)
      const params = new URLSearchParams(window.location.search);
      const langParam = params.get('lang');
      if (langParam === 'en' || langParam === 'pt') {
        setLocale(langParam);
        try {
          localStorage.setItem('faei_lang', langParam);
        } catch (e) {}
        return;
      }

      // 2. Check localStorage fallback
      try {
        const savedLang = localStorage.getItem('faei_lang');
        if (savedLang === 'en' || savedLang === 'pt') {
          setLocale(savedLang);
          return;
        }
      } catch (e) {}
    }

    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const brazilTimezones = [
        'America/Araguaina',
        'America/Bahia',
        'America/Belem',
        'America/Boa_Vista',
        'America/Campo_Grande',
        'America/Cuiaba',
        'America/Fortaleza',
        'America/Maceio',
        'America/Manaus',
        'America/Noronha',
        'America/Porto_Velho',
        'America/Recife',
        'America/Rio_Branco',
        'America/Sao_Paulo'
      ];
      
      const isBrazil = tz && (
        brazilTimezones.includes(tz) || 
        tz.startsWith('Brazil/') || 
        tz === 'America/Fernando_de_Noronha'
      );
      
      if (!isBrazil) {
        setLocale('en');
      }
    } catch (e) {
      console.error("Error detecting timezone", e);
    }
  }, []);

  const t = (key) => {
    const activeLocale = mounted ? locale : 'pt';
    return translations[activeLocale]?.[key] || translations['pt']?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ locale, t, mounted }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    return {
      locale: 'pt',
      mounted: false,
      t: (key) => translations['pt']?.[key] || key
    };
  }
  return context;
};
